import React from "react";
import { format } from "date-fns";
import { nb } from "date-fns/locale";

import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";

import { Input } from "../../../../Partials/Input";
import { Button } from "../../../../Partials/Button";
import classNames from "classnames";
import { StreamLineIcon } from "../../../../../SvgIcon/StreamLineIcon";

interface BookingCalendarInputProps {
  inputValue: string;
  handleInputChange: (value: string) => void;
  onButtonClick: () => void;
  disabled?: boolean;
}

const DATE_FORMAT = "dd-MM-y";

export const BookingCalendarInput = React.forwardRef<
  HTMLButtonElement,
  BookingCalendarInputProps
>((props, ref) => {
  const {
    inputValue,
    handleInputChange,
    onButtonClick,
    disabled = false,
  } = props;

  const { inputs } = useInsuranceLabels();

  return (
    <Input
      type="text"
      label={inputs.dateLabel}
      name="date"
      placeholder={format(new Date(), DATE_FORMAT, { locale: nb })}
      externalValue={inputValue}
      onValueChange={handleInputChange}
      backgroundVariant="blue-light"
      postfixIcon={
        <Button
          ref={ref}
          className={classNames("bookingCalendarInput__button", {
            ["bookingCalendarInput__button--disabled"]: disabled,
          })}
          aria-label={inputs.dateLabel}
          onClick={onButtonClick}
          type="clear"
          size="small"
          tier="primary"
          disabled={disabled}
        >
          <span className="insuranceButton__label">
            <StreamLineIcon
              className="bookingCalendarInput__buttonIcon"
              iconName="s-calendar"
            />
          </span>
        </Button>
      }
      disabled={disabled}
    />
  );
});
